import plugins from "./plugins.init.js";
import bio from "./modules/bio.js";
import nav from "./modules/nav.js";
import latest from "./modules/latest.js";
import backtotop from "./modules/backtotop.js";

/* Template Name: Dennis - Tailwind CSS Personal Portfolio Template
   Author: Shreethemes
   Email: support@shreethemes.in
   Website: https://shreethemes.in
   Version: 1.0.0
   Created: March 2022
   File Description: Main JS file of the template
*/


/*********************************/
/*         INDEX                 */
/*================================
 *     01.  Preloader            *
 *     02.  Menus                *
 *     03.  Back to top          *
 ================================*/
window.addEventListener('load', fn, false)

//  window.onload = function loader() {
async function fn() {

  plugins();
  bio();
  nav();
  await latest();
  backtotop();
}

/*********************/
/*     Menus         */
/*********************/

function windowScroll() {
  const navbar = document.getElementById("navbar");
  if (
    document.body.scrollTop >= 50 ||
    document.documentElement.scrollTop >= 50
  ) {
    navbar.classList.add("is-sticky");
  } else {
    navbar.classList.remove("is-sticky");
  }
}

window.addEventListener('scroll', (ev) => {
  ev.preventDefault();
  windowScroll();
})

// Navbar Active Class
try {
  var spy = new Gumshoe('#navbar-navlist a', {
    // Active classes
    // navClass: 'active', // applied to the nav list item
    // contentClass: 'active', // applied to the content
    offset: 80
  });
} catch (error) {

}

// Smooth scroll 
try {
  var scroll = new SmoothScroll('#navbar-navlist a', {
    speed: 800,
    offset: 80
  });
} catch (error) {

}

// Menu Collapse
const toggleCollapse = (elementId, show = true) => {
  const collapseEl = document.getElementById(elementId);
  if (show) {
    collapseEl.classList.remove('hidden');
  } else {
    collapseEl.classList.add('hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Toggle target elements using [data-collapse]
  document.querySelectorAll('[data-collapse]').forEach(function (collapseToggleEl) {
    var collapseId = collapseToggleEl.getAttribute('data-collapse');

    collapseToggleEl.addEventListener('click', function () {
      toggleCollapse(collapseId, document.getElementById(collapseId).classList.contains('hidden'));
    });
  });
});

window.toggleCollapse = toggleCollapse;

/*********************/
/*    Back To TOp    */
/*********************/

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  var mybutton = document.getElementById("back-to-top");
  if (mybutton != null) {
    if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
      mybutton.classList.add("block");
      mybutton.classList.remove("hidden");
    } else {
      mybutton.classList.add("hidden");
      mybutton.classList.remove("block");
    }
  }
}

/*********************/
/*      WoW Js       */
/*********************/
try {
  new WOW().init();
} catch (error) {

}

const clipbutton = document.getElementById("clipboardButton");
const clipMessage = document.getElementById("clipMessage");
if (clipbutton && clipMessage) {
  clipbutton.addEventListener("click", () => {
    const bioLabel = document.querySelector(".bio-button.selected");
    if (bioLabel) {
      const target = bioLabel.getAttribute("data-target");
      if (target) {
        const bio = document.querySelector(`[data-bio|=${target}`);
        if (bio) {
          navigator.clipboard.writeText(bio.innerText);
          clipMessage.classList.remove("hidden");
          setTimeout(() => {
            clipMessage.classList.add("hidden");
          }, 1500);
        }
      }
    } 
  });
}



